<template>
  <div id="checkout_calendar">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60">
          <div class="l-main__head">
            <a
              href="javascript:void(0)"
              @click.prevent="backPagePrevious()"
              class="l-main__head--control l-main__head--control--back"
            >
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="" />
            </a>
            <div class="l-main__head--title">予約日時を選ぶ</div>
            <a href="#" class="l-main__head--control"> </a>
          </div>
        </div>
        <div class="l-calendar l-calendar_wrap">
          <div class="l-calendar_title">
            <button class="c-btn-prev" @click.prevent="getCalendarPrev()" :disabled="nowPage <= 1 || loading"><div class="arr-prev"></div></button>
            <div class="c-title">{{ title }}</div>
            <button class="c-btn-next" @click.prevent="getCalendarNext()" :disabled="nowPage == limitPage || loading"><div class="arr-next"></div></button>
          </div>
          <div class="l-calendar_content">
            <div class="d-flex">
              <div class="l-calendar_row"></div>
              <div class="l-calendar_row" v-for="(value, name, index) in list.book" :key="index">
                <div  class="l-calendar_date">
                  <span v-if="isNextMonth(name)">{{changeDay(name).month}}/</span>{{changeDay(name).date}}
                  <div :style="{color: setColor(changeDay(name).day)}">{{changeDay(name).day}}</div>
                </div>
              </div>
            </div>
            <div class="l-calendar_content_scroll">
              <div class="l-calendar_content_inner">
                <div  class="l-calendar_row">
                  <div class="l-calendar_time" v-for="(time, tindex) in timelist" :key="tindex" >
                    <template v-if="time == 'am'">午前</template>
                    <template v-else-if="time == 'pm'">午後</template>
                    <template v-else>{{time}}</template>
                  </div>
                </div>
                <div class="l-calendar_row" v-for="(value, name, index) in list.book" :key="index">
                  <div v-for="(item, itemName, itemIndex) in value" :key="itemIndex" class="l-calendar_ratio" >
                    <input 
                      type="radio" 
                      :disabled="item == 3 || item == 0" name="reservation_date" 
                      :value="setValue(name,itemName)" 
                      :id=" 'reservation_date_' + index + itemIndex"
                      v-model="selectedDate"
                    />
                    <label :for=" 'reservation_date_' + index + itemIndex">
                      <img :src="changeIcon(item)" alt="" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="l-calendar_footer">
            <button @click.prevent="addTimeCart" class="l-calendar_footer_button" :disabled="selectDate ? false :true">日時を決定する</button>
          </div>
        </div>
      </section>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
       <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import firebase from "../common/firebaseProject";
import { getUser, getProvider } from "../store/firestore";
import dayjs from "dayjs";
import ja from 'dayjs/locale/ja';
dayjs.locale(ja);
import PopAlert from "../components/PopAlert.vue";


export default Vue.extend({
  name: "MobileOrderCalendar",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'alert': Alert,
    PopAlert
  },
  mixins: [Tenant],
  async created(){
    this.tenantId = this.$route.params.id;
    this.orderId = this.$route.params.orderId;
    const userId = this.$store.state.userId;
    const tenant = await getProvider(this.tenantId);
    if(userId){
      this.user = await getUser(userId);
    }
    this.tenant = tenant;
  },
  data(){
    return {
      user: undefined,
      tenants: [],
      loading: false,
      value: dayjs(),
      list:{},
      timelist:[],
      selectDate:null,
      nowPage: 1,
      limitPage:1
    }
  },
  async mounted() {
    Common.initDom();
    this.getDataBook();
  },
  computed: {
    title() {return dayjs(this.value).format('M月');},
    selectedDate:{
      get () {return this.selectDate;},
      set (value) {this.selectDate = value;}
    }
  },
  methods: {
    async getDataBook() {
      this.loading = true;
      const cartData = {...this.$store.state.cart};
      let orderType = null;
      let numberOfPeople = 0;
      let requiredTime = 0;
      for (const [key, tenantCart] of Object.entries(cartData)) {

        if (this.tenantId == tenantCart.tenantId) {
          orderType = tenantCart.orderType;
          numberOfPeople = (tenantCart.reservationNumberOfPeople) ? tenantCart.reservationNumberOfPeople : 0;

          //所要時間を算出する
          if (tenantCart.orderProducts.length > 0) {
            for (let i=0; i<tenantCart.orderProducts.length; i++) { 
              //商品の所要時間 個数分　×
              const _time = tenantCart.orderProducts[i].requiredTime;
              const _quantity = tenantCart.orderProducts[i].quantity;
              requiredTime = (_time) ? (_time * _quantity) + requiredTime : requiredTime;
              //オプションの所要時間
              if (tenantCart.orderProducts[i].options.length > 0) {
                for (let j=0; j<tenantCart.orderProducts[i].options.length; j++) {
                  const _optionTime = tenantCart.orderProducts[i].options[j].requiredTime;
                  requiredTime = (_optionTime) ? _optionTime + requiredTime : requiredTime;
               }
              }
            }
          }
        }
      }

      const callable = firebase.functions('asia-northeast1').httpsCallable('reservationBook');
      const request = {
        "tenantId": this.tenantId, //"175a616d7c0af8801f595c9ed1c", //テナントID
        "orderType": orderType, //注文タイプ　1：モバイルオーダー、2：ドライブスルー（対象外）3：来店予約
        "numberOfPeople": numberOfPeople, //人数（全商品分の合算）
        "requiredTime": requiredTime, //所要時間（分）（全商品、全オプション分の合算）
        "pageNo": this.nowPage //ページ番号（最大4）（7日ごとに返却）
      };
      const result = await callable(request)
        .catch(async e => {
          this.loading = false;
          await this.confirm("カレンダー情報取得時にエラーが発生しました。" + (e?.message||""), true);
          this.$router.push('/mobileorder/checkout');
          //return;
          throw e;
        });
      if (result.data.status == 'SUCCEED') {
        //カレンダー状況取得
        const rd = result.data;
        this.list = rd;

        //最終ページ番号
        this.timelist = [];
        this.limitPage = rd.lastPageNo;
        var val = Object.entries(this.list.book)[0];

        for (const key in val[1]) { this.timelist.push(key); }
      }
      //タイトルの日付を取得するため、リストの最初の日時を取得
      if (this.list) this.value = val[0];
      this.loading = false;
    },
    changeIcon(item) {
       // 0 = ハイフン、  1 = ○、  2 = △、3 = ×
      switch(item) {
        case 1 :
          return "/assets/images/icon/icon-c-circle.svg"; 
        case 2 :
          return "/assets/images/icon/icon-c-triangle.svg"; 
        case 3 :
          return "/assets/images/icon/icon-c-peke.svg"; 
        default:
          return "/assets/images/icon/icon-c-hyphen.svg"; 
      }
    },
    isNextMonth(date) {
      let day = dayjs(new Date(date));
      return (day.date() == 1)
    },
    changeDay(date) {
      let day = dayjs(new Date(date));
      return {
        month:day.format('M'),
        date:day.date(),
        day:day.format('dd')
      };
    },
    setColor(day) {
      switch(day) {
        case "土" :
          return "#0095C1"; 
        case "日" :
          return "#FF0000"; 
        default:
          return "#2B2B2B"; 
      }
    },
    async addTimeCart() {
      if (!this.selectDate) {
        await this.confirm(`日時が選択されていません。`, true);
        return;
      }
      let selected = this.selectDate.split('_');
      const cartData = {...this.$store.state.cart};

      let isCouponCode = null
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == this.orderId){
          tenantCart.reservationDate = selected[0];
          tenantCart.reservationTime = selected[1];
        }
        if (tenantCart.couponCode) isCouponCode = tenantCart.couponCode
      }

      let data = {cartData: cartData }

      if (isCouponCode) {
        data["couponCode"] = isCouponCode
      }

      this.$store.dispatch('updateCart', data)
      .then(() => { this.$router.push({ path: `/mobileorder/checkout` , query: { noAutoApplyCoupon: true }}); })
      .catch(err => {
        if (err.code == "invalid-cart-item") {
          this.$router.push('/mobileorder/cart');
          return;
        }
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
    },
    setValue(name,itemName) {
      return name + '_' + itemName;
    },
    getCalendarPrev() {
      this.nowPage --;
      this.getDataBook();
    },
    getCalendarNext() {
      this.nowPage ++;
      this.getDataBook();
    }
  }
})
</script>